var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "min-height": "calc(100vh - 190px)" } },
    [
      _c(
        "div",
        { staticClass: "message" },
        [
          _c(
            "el-card",
            { attrs: { "body-style": { padding: "0 20px 20px" } } },
            [
              _c(
                "div",
                {},
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.changeTab },
                      model: {
                        value: _vm.currentTab,
                        callback: function ($$v) {
                          _vm.currentTab = $$v
                        },
                        expression: "currentTab",
                      },
                    },
                    _vm._l(_vm.headerList, function (item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: {
                          label: item.label,
                          name: item.value.toString(),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              parseInt(_vm.currentTab) === 1
                ? _c(
                    "el-alert",
                    { attrs: { closable: "" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("p", [_vm._v("上传图片时会生成缩略图")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "未设置按照系统默认生成，系统默认：大图800*800，中图300*300，小图150*150"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "水印只在上传图片时生成，原图，大中小缩略图上都按照比例存在。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "若上传图片时未开启水印，则该图在开启水印之后依旧无水印效果。"
                          ),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _c(
                    "el-alert",
                    { attrs: { closable: "" } },
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          parseInt(_vm.currentTab) === 2
                            ? _c("p", [
                                _vm._v("\n            七牛云开通方法："),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://doc.crmeb.com/single/v5/7792",
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("点击查看")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          parseInt(_vm.currentTab) === 3
                            ? _c("p", [
                                _vm._v("\n            阿里云oss开通方法："),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://doc.crmeb.com/single/v5/7790",
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("点击查看")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          parseInt(_vm.currentTab) === 4
                            ? _c("p", [
                                _vm._v("\n            腾讯云cos开通方法："),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://doc.crmeb.com/single/v5/7791",
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("点击查看")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          parseInt(_vm.currentTab) === 5
                            ? _c("p", [
                                _vm._v("\n            京东云cos开通方法："),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://doc.crmeb.com/single/v5/8522",
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("点击查看")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          parseInt(_vm.currentTab) === 6
                            ? _c("p", [
                                _vm._v("\n            华为云cos开通方法："),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://doc.crmeb.com/single/v5/8523",
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("点击查看")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          parseInt(_vm.currentTab) === 7
                            ? _c("p", [
                                _vm._v("\n            天翼云cos开通方法："),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://doc.crmeb.com/single/v5/8524",
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("点击查看")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "第一步： 添加【存储空间】（空间名称不能重复）"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("第二步： 开启【使用状态】")]),
                          _vm._v(" "),
                          parseInt(_vm.currentTab) === 2
                            ? [
                                _c("p", [
                                  _vm._v(
                                    "第三步（必选）： 选择云存储空间列表上的修改【空间域名操作】"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "第四步（必选）： 选择云存储空间列表上的修改【CNAME配置】，打开后复制记录值到对应的平台解析"
                                  ),
                                ]),
                              ]
                            : [
                                _c("p", [
                                  _vm._v(
                                    "第三步（可选）： 选择云存储空间列表上的修改【空间域名操作】"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "第四步（可选）： 选择云存储空间列表上的修改【CNAME配置】，打开后复制记录值到对应的平台解析"
                                  ),
                                ]),
                              ],
                        ],
                        2
                      ),
                    ],
                    2
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      parseInt(_vm.currentTab) === 1
        ? _c(
            "div",
            { staticClass: "pt10" },
            [
              _c(
                "el-card",
                { staticClass: "ivu-mt" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("span", { staticClass: "save-type" }, [
                            _vm._v(" 存储方式： "),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.changeSave },
                              model: {
                                value: _vm.upload_type,
                                callback: function ($$v) {
                                  _vm.upload_type = $$v
                                },
                                expression: "upload_type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("本地存储"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("七牛云存储"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "3" } }, [
                                _vm._v("阿里云存储"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "4" } }, [
                                _vm._v("腾讯云存储"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "5" } }, [
                                _vm._v("京东云存储"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "6" } }, [
                                _vm._v("华为云存储"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "7" } }, [
                                _vm._v("天翼云存储"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "ivu-mt" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formValidate",
                      attrs: {
                        model: _vm.formValidate,
                        rules: _vm.ruleValidate,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "abbreviation" },
                        [
                          _c("div", { staticClass: "top" }, [
                            _c("div", { staticClass: "topBox" }, [
                              _c("div", { staticClass: "topLeft" }, [
                                _c("div", { staticClass: "img" }, [
                                  _c("img", {
                                    staticClass: "imgs",
                                    attrs: {
                                      alt: "",
                                      src: require("@/assets/images/abbreviationBig.png"),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", [_vm._v("缩略大图")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "topRight" },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "宽：" } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticClass: "topIput",
                                          attrs: {
                                            placeholder: "请输入宽度",
                                            type: "number",
                                          },
                                          model: {
                                            value:
                                              _vm.formValidate.thumb_big_width,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formValidate,
                                                "thumb_big_width",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formValidate.thumb_big_width",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "append" },
                                              slot: "append",
                                            },
                                            [_vm._v("px")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "高：" } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticClass: "topIput",
                                          attrs: {
                                            placeholder: "请输入高度",
                                            type: "number",
                                          },
                                          model: {
                                            value:
                                              _vm.formValidate.thumb_big_height,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formValidate,
                                                "thumb_big_height",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formValidate.thumb_big_height",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "append" },
                                              slot: "append",
                                            },
                                            [_vm._v("px")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "topBox" }, [
                              _c("div", { staticClass: "topLeft" }, [
                                _c("div", { staticClass: "img" }, [
                                  _c("img", {
                                    staticClass: "imgs",
                                    attrs: {
                                      alt: "",
                                      src: require("@/assets/images/abbreviation.png"),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", [_vm._v("缩略中图")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "topRight" },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "宽：" } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticClass: "topIput",
                                          attrs: {
                                            placeholder: "请输入宽度",
                                            type: "number",
                                          },
                                          model: {
                                            value:
                                              _vm.formValidate.thumb_mid_width,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formValidate,
                                                "thumb_mid_width",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formValidate.thumb_mid_width",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "append" },
                                              slot: "append",
                                            },
                                            [_vm._v("px")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "高：" } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticClass: "topIput",
                                          attrs: {
                                            placeholder: "请输入高度",
                                            type: "number",
                                          },
                                          model: {
                                            value:
                                              _vm.formValidate.thumb_mid_height,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formValidate,
                                                "thumb_mid_height",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formValidate.thumb_mid_height",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "append" },
                                              slot: "append",
                                            },
                                            [_vm._v("px")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "topBox" }, [
                              _c("div", { staticClass: "topLeft" }, [
                                _c("div", { staticClass: "img" }, [
                                  _c("img", {
                                    staticClass: "imgs",
                                    attrs: {
                                      alt: "",
                                      src: require("@/assets/images/abbreviationSmall.png"),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", [_vm._v("缩略小图")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "topRight" },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "宽：" } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticClass: "topIput",
                                          attrs: {
                                            placeholder: "请输入宽度",
                                            type: "number",
                                          },
                                          model: {
                                            value:
                                              _vm.formValidate
                                                .thumb_small_width,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formValidate,
                                                "thumb_small_width",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formValidate.thumb_small_width",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "append" },
                                              slot: "append",
                                            },
                                            [_vm._v("px")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "高：" } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticClass: "topIput",
                                          attrs: {
                                            placeholder: "请输入高度",
                                            type: "number",
                                          },
                                          model: {
                                            value:
                                              _vm.formValidate
                                                .thumb_small_height,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formValidate,
                                                "thumb_small_height",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formValidate.thumb_small_height",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "append" },
                                              slot: "append",
                                            },
                                            [_vm._v("px")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content mt30" }, [
                            _vm.formValidate.image_watermark_status === 1
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "水印类型：",
                                          "label-width": "160px",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value:
                                                _vm.formValidate.watermark_type,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formValidate,
                                                  "watermark_type",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formValidate.watermark_type",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 1 } },
                                              [_vm._v("图片")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 2 } },
                                              [_vm._v("文字")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.formValidate.watermark_type === 1
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "flex" },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "contentIput",
                                                  attrs: {
                                                    label: "水印透明度：",
                                                    "label-width": "160px",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticClass: "topIput",
                                                    attrs: {
                                                      placeholder:
                                                        "请输入水印透明度",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formValidate
                                                          .watermark_opacity,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formValidate,
                                                          "watermark_opacity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formValidate.watermark_opacity",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "contentIput",
                                                  attrs: {
                                                    label: "水印倾斜度：",
                                                    "label-width": "160px",
                                                    prop: "mail",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticClass: "topIput",
                                                    attrs: {
                                                      placeholder:
                                                        "请输入水印倾斜度",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formValidate
                                                          .watermark_rotate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formValidate,
                                                          "watermark_rotate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formValidate.watermark_rotate",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex" },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "contentIput",
                                                  attrs: {
                                                    label: "水印图片：",
                                                    "label-width": "160px",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "picBox",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.modalPicTap(
                                                            "单选"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm.formValidate
                                                        .watermark_image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pictrue",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: _vm
                                                                    .formValidate
                                                                    .watermark_image,
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad acea-row row-center-wrapper",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-picture-outline",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "24px",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "contentIput",
                                                  attrs: {
                                                    label: "水印位置：",
                                                    "label-width": "160px",
                                                    prop: "mail",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "conents" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "positionBox",
                                                        },
                                                        _vm._l(
                                                          _vm.boxs,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c("div", {
                                                              key: index,
                                                              staticClass:
                                                                "topIput box",
                                                              class:
                                                                _vm.positionId ===
                                                                item.id
                                                                  ? "on"
                                                                  : "",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.bindbox(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            })
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.positiontlt
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex" },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "contentIput",
                                                  attrs: {
                                                    label: "水印横坐标偏移量：",
                                                    "label-width": "160px",
                                                    prop: "name",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      staticClass: "topIput",
                                                      staticStyle: {
                                                        width: "240px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "请输入水印横坐标偏移量",
                                                        type: "number",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .watermark_x,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate,
                                                            "watermark_x",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.watermark_x",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "append",
                                                          },
                                                          slot: "append",
                                                        },
                                                        [_vm._v("px")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "contentIput",
                                                  attrs: {
                                                    label: "水印纵坐标偏移量：",
                                                    "label-width": "160px",
                                                    prop: "mail",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      staticClass: "topIput",
                                                      staticStyle: {
                                                        width: "240px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "请输入水印纵坐标偏移量",
                                                        type: "number",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .watermark_y,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate,
                                                            "watermark_y",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.watermark_y",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "append",
                                                          },
                                                          slot: "append",
                                                        },
                                                        [_vm._v("px")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _c(
                                          "div",
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex" },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "contentIput",
                                                    attrs: {
                                                      label: "水印文字：",
                                                      "label-width": "160px",
                                                      prop: "name",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticClass: "topIput",
                                                      attrs: {
                                                        placeholder:
                                                          "请输入水印文字",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .watermark_text,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate,
                                                            "watermark_text",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.watermark_text",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "contentIput",
                                                    attrs: {
                                                      label: "水印文字大小：",
                                                      "label-width": "160px",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticClass: "topIput",
                                                      attrs: {
                                                        placeholder:
                                                          "请输入水印文字大小",
                                                        type: "number",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .watermark_text_size,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate,
                                                            "watermark_text_size",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.watermark_text_size",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "flex" },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "contentIput",
                                                    attrs: {
                                                      label: "水印字体颜色：",
                                                      "label-width": "160px",
                                                      prop: "name",
                                                    },
                                                  },
                                                  [
                                                    _c("el-color-picker", {
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .watermark_text_color,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate,
                                                            "watermark_text_color",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.watermark_text_color",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "contentIput",
                                                    attrs: {
                                                      label: "水印位置：",
                                                      "label-width": "160px",
                                                      prop: "mail",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "conents",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "positionBox",
                                                          },
                                                          _vm._l(
                                                            _vm.boxs,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c("div", {
                                                                key: index,
                                                                staticClass:
                                                                  "topIput box",
                                                                class:
                                                                  _vm.positionId ===
                                                                  item.id
                                                                    ? "on"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.bindbox(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.positiontlt
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "flex" },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "contentIput",
                                                    attrs: {
                                                      label:
                                                        "水印字体旋转角度：",
                                                      "label-width": "160px",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticClass: "topIput",
                                                      attrs: {
                                                        placeholder:
                                                          "请输入水印字体旋转角度",
                                                        type: "number",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.formValidate
                                                            .watermark_text_angle,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.formValidate,
                                                            "watermark_text_angle",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formValidate.watermark_text_angle",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "contentIput",
                                                    attrs: {
                                                      label:
                                                        "水印横坐标偏移量：",
                                                      "label-width": "160px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-input",
                                                      {
                                                        staticClass: "topIput",
                                                        attrs: {
                                                          placeholder:
                                                            "请输入水印横坐标偏移量",
                                                          type: "number",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.formValidate
                                                              .watermark_x,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.formValidate,
                                                              "watermark_x",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formValidate.watermark_x",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              slot: "append",
                                                            },
                                                            slot: "append",
                                                          },
                                                          [_vm._v("px")]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "contentIput",
                                                attrs: {
                                                  label: "水印横坐纵偏移量：",
                                                  "label-width": "160px",
                                                  prop: "mail",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-input",
                                                  {
                                                    staticClass: "topIput",
                                                    attrs: {
                                                      placeholder:
                                                        "请输入水印横坐纵偏移量",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formValidate
                                                          .watermark_y,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formValidate,
                                                          "watermark_y",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formValidate.watermark_y",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          slot: "append",
                                                        },
                                                        slot: "append",
                                                      },
                                                      [_vm._v("px")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSubmit("formValidate")
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "pt10" },
            [
              _c(
                "el-card",
                {
                  staticClass: "ivu-mt",
                  attrs: { bordered: false, shadow: "never" },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "mb20" },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticClass: "btn-box" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: { click: _vm.addStorageBtn },
                              },
                              [_vm._v("添加存储空间")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown",
                              { on: { command: _vm.handleCommand } },
                              [
                                _c("span", {
                                  staticClass:
                                    "iconfont icongengduo2 pointer ml10",
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: 1 } },
                                      [_vm._v("同步存储空间")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: 2 } },
                                      [_vm._v("修改配置信息")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      ref: "table",
                      staticClass: "mt14",
                      attrs: {
                        data: _vm.levelLists,
                        "highlight-current-row": "",
                        "no-filtered-userFrom-text": "暂无筛选结果",
                        "no-userFrom-text": "暂无数据",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "储存空间名称", "min-width": "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.name))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "区域", "min-width": "90" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row._region))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "空间域名", "min-width": "130" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.domain))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "使用状态", "min-width": "90" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-switch", {
                                  staticClass: "defineSwitch",
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                    value: scope.row.status,
                                    "active-text": "开启",
                                    "inactive-text": "关闭",
                                    size: "large",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeSwitch(
                                        scope.row,
                                        _vm.index
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "status", $$v)
                                    },
                                    expression: "scope.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "创建时间", "min-width": "130" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row._add_time)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "更新时间", "min-width": "130" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row._update_time)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { fixed: "right", label: "操作", width: "220" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.domain &&
                                scope.row.domain != scope.row.cname
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.config(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("CNAME配置")]
                                      ),
                                      _vm._v(" "),
                                      _c("el-divider", {
                                        attrs: { direction: "vertical" },
                                      }),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("修改空间域名")]
                                ),
                                _vm._v(" "),
                                _c("el-divider", {
                                  attrs: { direction: "vertical" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(
                                          scope.row,
                                          "删除该数据",
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row row-right page" },
                    [
                      _vm.total
                        ? _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.list.page,
                              "page-size": _vm.list.limit,
                              "page-sizes": [10, 15, 20],
                              total: _vm.total,
                              layout: "total, prev, pager, next, jumper",
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.getlist,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.configuModal, width: "550px" },
          on: {
            "update:visible": function ($event) {
              _vm.configuModal = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 1, title: "CNAME配置" } },
            [
              _c("el-descriptions-item", { attrs: { label: "主机记录" } }, [
                _vm._v(_vm._s(_vm.configData.domain)),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "记录类型" } }, [
                _vm._v("CNAME"),
              ]),
              _vm._v(" "),
              _c(
                "el-descriptions-item",
                { attrs: { label: "记录值", labelClassName: "desc-label" } },
                [
                  _vm._v("\n        " + _vm._s(_vm.configData.cname)),
                  _c(
                    "span",
                    {
                      staticClass: "copy copy-data",
                      attrs: { "data-clipboard-text": _vm.configData.cname },
                      on: {
                        click: function ($event) {
                          return _vm.insertCopy(_vm.configData.cname)
                        },
                      },
                    },
                    [_vm._v("复制")]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }